var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.002,
    height: 16.998,
    viewBox: "0 0 19.002 16.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_18",
    "data-name": "Subtraction 18",
    d: "M-15078.5,611h-18a.5.5,0,0,1-.5-.5v-7.514a.507.507,0,0,1,.17-.375l3.831-3.338V594.5a.5.5,0,0,1,.5-.5h14a.5.5,0,0,1,.5.5v16A.5.5,0,0,1-15078.5,611Zm-13-12.872a.488.488,0,0,1,.326.121l5,4.361a.5.5,0,0,1,.17.375V610h7V595h-13v3.13Zm-.5,7.87h1v4h4v-6.786l-4.5-3.922-4.5,3.922V610h4v-4Zm10-3h-1v-1h1v1Zm0-4h-1v-1h1v1Zm-4,0h-1v-1h1v1Z",
    transform: "translate(15097 -594.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingSummary);
export default __webpack_public_path__ + "static/media/building-summary.216e44b2c6bf1e382437adac6aadad88.svg";
export { ForwardRef as ReactComponent };